/**
 * Generates a node from a node handler
 * @param {object} nodehandler - The node handler spec
 * @returns {object} - The generated node
 */
export function generateNodeFromNodeHandler(nodehandler) {
	const methods = Object.keys(nodehandler.methods);
	const method = methods.length === 1 ? methods[0] : '';
	const outputs = method ? nodehandler.methods[method].outputs : null;
	const name = (method && nodehandler.methods[method].name) || method;
	const node = {
		type: nodehandler.type,
		name,
		method,
		parameters: [],
		outputs: {}
	};
	if (method) {
		node.outputs = Object.keys(outputs).reduce((col, cur) => {
			const output = Object.assign({ context: null, routes: [] }, outputs[cur]);
			col[cur] = output;
			delete output.schema;
			delete output.name;
			delete output.description;
			return col;
		}, { });
	}
	return node;
}

/**
 * This is a callback invoked in FlowView when new trigger is created.
 * The code is here so it can be tested.
 * @param {Object} flow - the flow that will be invoked by the trigger
 * @param {Object} triggerType - the trigger type
 * @param {Object} triggerId - the trigger id
 * @param {Object} trigger - the trigger
 */
export function addTriggerToFlow(flow, triggerType, triggerId, trigger) {
	if (!flow.flow.triggers) {
		// unbound flow use case
		flow.flow.triggers = {};
	}
	if (!flow.flow.triggers[triggerType]) {
		// flow has not this trigger type yet
		flow.flow.triggers[triggerType] = {};
	}
	flow.flow.triggers[triggerType][triggerId] = trigger;
}
